import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useManageSlab = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('manageSlab', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['slabs'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useManageSlab;
